export default "__VITE_ASSET__BaE5Fz9Z__"